angular.module("eventHosts")

    .controller("EventHostsListCtrl", ['LoginService', '$rootScope', '$scope', '$http', '$interval', '$q', 'i18nService', 'Restangular', 'uiGridTreeViewConstants', 'gridService', 'treeService', 'modalService', '$uibModal', '$filter', '$translate', '$state',
        function (LoginService, $rootScope, $scope, $http, $interval, $q, i18nService, Restangular, uiGridTreeViewConstants, gridService, treeService, modalService, $uibModal, $filter, $translate, $state) {

            //Comprobamos si tiene permiso escritura
            $scope.allowWrite = LoginService.permissionExist("EVENT_HOSTS_WRITE");

            $rootScope.title = $filter('translate')('event-hosts.title');
            $rootScope.breadcrumb = [
                { title: $filter('translate')('event-hosts.title') }
            ];

            $scope.gridOptions = {
                pdfTitle: $filter('translate')('event-hosts.pdf_title'),
                exporterMenuCsv: true,
                enableGridMenu: true,
                gridMenuShowHideColumns: false,
                enableSorting: true,
                paginationPageSizes: [20, 40, 60],
                paginationPageSize: 20,
                rowTemplate: '<div ng-dblclick="grid.appScope.goToEdit(row.entity)" ng-repeat="(colRenderIndex, col) in colContainer.renderedColumns track by col.uid" class="ui-grid-cell" ng-class="col.colIndex()" ui-grid-cell style="cursor:pointer;"></div>',
                onRegisterApi: function (gridApi) {
                    this.gridApi = gridApi;
                },
                columnDefs: [
                    { name: 'id', visible: false, enableHiding: false, exporterSuppressExport: true },
                    {
                        name: 'icon', displayName: $filter('translate')('general.icon'), cellTemplate: '<div class="ui-grid-cell-contents">' +
                            '<i class="fas fa-{{row.entity.icon}} text-primary m-l-sm" ></i>' +
                            '</div>', width: 80, enableFiltering: false, enableHiding: false },
                    { name: 'color', displayName: $filter('translate')('general.color'), enableFiltering: false, cellTemplate: gridService.colorTemplate("color"), maxWidth: 30},
                    { name: 'name', displayName: $filter('translate')('general.name'), enableFiltering: true, enableHiding: false },
                    {
                        name: ' ', width: 150, exporterSuppressExport: true, enableSorting: false, enableHiding: false, enableFiltering: false, enableColumnMenu: false, cellTemplate: gridService.actionTemplate([
                            { title: $filter('translate')('general.button_edit'), action: 'ui-sref="event_hosts.edit({id:row.entity.id})"', cssIconClass: "fa fa-edit" },
                            { title: $filter('translate')('general.button_delete'), action: 'ng-click="grid.appScope.deleteDialog(row.entity.id,row.entity.name);" ng-if="grid.appScope.allowWrite"', cssIconClass: "fa fa-remove" }
                        ], { cssClass: "pull-right" })
                    },
                ],
                getData: function (options) {
                    return Restangular.all('EventHosts').getList(options);
                }
            };

            $scope.goToEdit = function (rowEntity) {
                $state.go("event_hosts.edit", { id: rowEntity.id });
            }


            $scope.deleteDialog = function (id, name) {
                $scope.id = id;
                $scope.name = name;
                modalService.confirm({
                    title: $filter('translate')('event-hosts.button_delete'),
                    message: $filter('translate')('event-hosts.delete_message') + " " + $scope.name + "?",
                    onAccept: function () {
                        Restangular.one('EventHosts', $scope.id).remove().then(function () {
                            toastr.success($filter('translate')('event-hosts.deleted_success'));
                            $scope.gridOptions.gridApi.core.raise.itemDeleted($scope);

                        }, function (response) {
                            $scope.errorMessage = response.message;
                        });
                    }
                });

            };

        }])

    ;